import type { Message } from '../types';

export interface SenderLabel {
  primary: string;
  secondary?: string;
}

export function resolveSenderLabel({
  message,
  workerUserId,
  workerName,
}: {
  message: Message;
  workerUserId: number | null;
  workerName: string | null;
}): SenderLabel {
  if (message.message_type === 'system') return { primary: 'System' };

  if (
    workerUserId != null &&
    message.sender_id != null &&
    Number(message.sender_id) === Number(workerUserId)
  ) {
    return { primary: workerName?.trim() || 'Worker' };
  }

  const senderName =
    typeof message.metadata?.sender_name === 'string'
      ? message.metadata.sender_name.trim()
      : '';
  return senderName
    ? { primary: 'Gravy Staff', secondary: `(${senderName})` }
    : { primary: 'Gravy Staff' };
}
